// Libs
import React from 'react';
import propTypes from 'prop-types';
import {
  createHistory,
  LocationProvider,
  useLocation,
} from '@gatsbyjs/reach-router';

// Styles
import './general.scss';

// Components
import Footer from '../Footer';
import LanguageButton from '../LanguageButton/LanguageButton';
import HeadHelmet from '../HeadHelmet';
import SeoNavBar from '../SeoNavBar';

const GatsbyLocationProvider = ({ children }) => {
  let history = {};
  if (typeof window !== 'undefined') {
    // window.location = res.data
    history = createHistory(window);
  }
  return <LocationProvider history={history}>{children}</LocationProvider>;
};

const PageContainer = ({
  originalPathPage,
  children,
  enableAlternateTags = true,
  externalDescription,
  hasLanguangeSwitcher = true,
  isGatsbyPage,
  richSnippets,
  title,
  translation,
  translations = [],
}) => {
  const location = useLocation();
  return (
    <>
      {hasLanguangeSwitcher && (
        <LanguageButton
          translations={translations}
          isGatsbyPage={isGatsbyPage}
        />
      )}
      <HeadHelmet
        title={title}
        externalDescription={externalDescription}
        translation={translation}
        originalPathPage={originalPathPage}
        enableAlternateTags={enableAlternateTags}
        richSnippets={richSnippets}
        translations={translations}
        isGatsbyPage={isGatsbyPage}
        location={location}
      />
      <SeoNavBar />
      {children}
      <Footer />
    </>
  );
};

const MainContainer = ({
  originalPathPage,
  children,
  enableAlternateTags,
  externalDescription,
  hasLanguangeSwitcher,
  isGatsbyPage,
  richSnippets,
  title,
  translation,
  translations,
}) => (
  <GatsbyLocationProvider>
    <PageContainer
      originalPathPage={originalPathPage}
      enableAlternateTags={enableAlternateTags}
      externalDescription={externalDescription}
      hasLanguangeSwitcher={hasLanguangeSwitcher}
      isGatsbyPage={isGatsbyPage}
      richSnippets={richSnippets}
      title={title}
      translation={translation}
      translations={translations}
    >
      {children}
    </PageContainer>
  </GatsbyLocationProvider>
);

export default MainContainer;
